// FETCH ALL SIZE MEASUREMENT MASTER
export const FETCH_SIZE_MEASUREMENT_MASTER_REQUEST = 'FETCH_SIZE_MEASUREMENT_MASTER_REQUEST';
export const FETCH_SIZE_MEASUREMENT_MASTER_SUCCESS = 'FETCH_SIZE_MEASUREMENT_MASTER_SUCCESS';
export const FETCH_SIZE_MEASUREMENT_MASTER_FAILURE = 'FETCH_SIZE_MEASUREMENT_MASTER_FAILURE';

// CREATE SIZE MEASUREMENT MASTER
export const CREATE_SIZE_MEASUREMENT_MASTER_REQUEST = 'CREATE_SIZE_MEASUREMENT_MASTER_REQUEST';
export const CREATE_SIZE_MEASUREMENT_MASTER_SUCCESS = 'CREATE_SIZE_MEASUREMENT_MASTER_SUCCESS';
export const CREATE_SIZE_MEASUREMENT_MASTER_FAILURE = 'CREATE_SIZE_MEASUREMENT_MASTER_FAILURE';

// UPDATE SIZE MEASUREMENT MASTER
export const UPDATE_SIZE_MEASUREMENT_MASTER_REQUEST = 'UPDATE_SIZE_MEASUREMENT_MASTER_REQUEST';
export const UPDATE_SIZE_MEASUREMENT_MASTER_SUCCESS = 'UPDATE_SIZE_MEASUREMENT_MASTER_SUCCESS';
export const UPDATE_SIZE_MEASUREMENT_MASTER_FAILURE = 'UPDATE_SIZE_MEASUREMENT_MASTER_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_REQUEST = 'FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_REQUEST';
export const FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_SUCCESS = 'FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_SUCCESS';
export const FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_FAILURE = 'FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_FAILURE';

// DELETE SIZE MEASUREMENT MASTER
export const DELETE_SIZE_MEASUREMENT_MASTER_REQUEST = 'DELETE_SIZE_MEASUREMENT_MASTER_REQUEST';
export const DELETE_SIZE_MEASUREMENT_MASTER_SUCCESS = 'DELETE_SIZE_MEASUREMENT_MASTER_SUCCESS';
export const DELETE_SIZE_MEASUREMENT_MASTER_FAILURE = 'DELETE_SIZE_MEASUREMENT_MASTER_FAILURE';

// FETCH ALL SIZES
export const FETCH_ALL_SIZES_REQUEST = 'FETCH_ALL_SIZES_REQUEST';
export const FETCH_ALL_SIZES_SUCCESS = 'FETCH_ALL_SIZES_SUCCESS';
export const FETCH_ALL_SIZES_FAILURE = 'FETCH_ALL_SIZES_FAILURE';

// FETCH ALL STYLE
export const FETCH_ALL_STYLE_REQUEST = 'FETCH_ALL_STYLE_REQUEST';
export const FETCH_ALL_STYLE_SUCCESS = 'FETCH_ALL_STYLE_SUCCESS';
export const FETCH_ALL_STYLE_FAILURE = 'FETCH_ALL_STYLE_FAILURE';

// FETCH ALL BUYER
export const FETCH_ALL_BUYER_REQUEST = 'FETCH_ALL_BUYER_REQUEST';
export const FETCH_ALL_BUYER_SUCCESS = 'FETCH_ALL_BUYER_SUCCESS';
export const FETCH_ALL_BUYER_FAILURE = 'FETCH_ALL_BUYER_FAILURE';

export const RESET_SIZE_MEASUREMENT_MASTER_INFO = 'RESET_SIZE_MEASUREMENT_MASTER_INFO';

export const CREATE_SIZE_MEASUREMENT_MASTER_FORM = 'CREATE_SIZE_MEASUREMENT_MASTER_FORM';

export const UPDATE_SIZE_MEASUREMENT_MASTER_FORM = 'UPDATE_SIZE_MEASUREMENT_MASTER_FORM';

// NAVIGATE TO SIZE MEASUREMENT DETAILS COMPONENT
export const NAVIGATE_SIZE_MEASUREMENT_DETAILS = 'NAVIGATE_SIZE_MEASUREMENT_DETAILS';

// NAVIGATE TO SIZE MWASUREMENT MASTER COMPONENT
export const NAVIGATE_SIZE_MEASUREMENT_MASTER = 'NAVIGATE_SIZE_MEASUREMENT_MASTER';
